import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import JsonExcel from 'vue-json-excel'
import Multiselect from 'vue-multiselect'


Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('downloadExcel', JsonExcel)
Vue.component('multiselect', Multiselect)
